import { UserManageWorkspace } from '../AttendancePage/UserManageWorkspace';

/**
 * 조직도 — 통합설정 › 조직 (2026-08-28 · 자리 재정의 판 4).
 *
 * ★★ **회사의 뼈대**를 정하는 자리다 — 부서·팀 만들기 · 이름 바꾸기 · 옮기기 · 팀장 지정.
 *    사용자 관리에서 꺼냈다: 거기는 **계정만** 다룬다(이름 · 계정명 · 비밀번호 · 상태 · 역할).
 *
 * ★ 화면 본체는 **같은 컴포넌트의 다른 얼굴**이다(`mode='org'`). 두 화면이 같은 목록·같은 조직
 *   데이터를 쓰므로 가르는 선은 화면이지 모듈이 아니다 — 1,700줄을 쪼개는 것 자체가 회귀 위험이다.
 */
export function OrgChartSection(): JSX.Element {
  return <UserManageWorkspace mode="org" />;
}
